<script>
import List, {
  Item,
  Graphic,
  Meta,
  Text,
  Label
} from '@smui/list';
import { onMount } from 'svelte';

 export let data;

 let paymentOptions = [  ];
 export let selected='';

 function getTransportPrice(cena,dobirka,freeFrom) {
   let text="";
   if(freeFrom!="0" && data.cart) {
     let sum=0;
     for(let i=0; i<data.cart.length; i++) {
        sum+=parseInt(data.cart[i].price);
     }

     if(sum>parseInt(freeFrom)) { return ""; }
   }
   if(dobirka && dobirka!=-1) { text='('+cena+',- | s dobírkou: '+dobirka+',-)'; }
   else { text='('+cena+',-)'; }
   return text;
 }

onMount(async () => {
  if(data) {
    if(data.config.delivery) {
      if(data.config.delivery.osobniodber && data.school.doprava!="doruceni") {
        let osobne = "Osobní odběr";
        if(data.config.delivery.osobniodber_misto!="") { osobne= 'Osobní odběr na adrese: '+data.config.delivery.osobniodber_misto; }
        paymentOptions.push (
           {
             title: osobne,
             value: 'osobne',
             disabled: false,
           }
        );
        if(selected=='') { selected='osobne'; }
      }
      if(data.config.delivery.zasilkovnacena && data.config.delivery.zasilkovnacena!="0" && data.config.delivery.zasilkovnacena!="-1" && data.school.doprava!="osobne") {
        paymentOptions.push (
           {
             title: 'Zásilkovna '+getTransportPrice(data.config.delivery.zasilkovnacena, data.config.delivery.zasilkovnadobirka, data.config.delivery.zasilkovnazdarma),
             value: 'zasilkovna',
             disabled: false,
           }
        );
        if(selected=='') { selected='zasilkovna'; }
      }
      if(data.config.delivery.kuryr && data.config.delivery.kuryrcena!="0" && data.config.delivery.kuryrcena!="-1" && data.school.doprava!="osobne") {
        paymentOptions.push (
           {
             title: 'Kurýrem '+data.config.delivery.kuryr+' '+getTransportPrice(data.config.delivery.kuryrcena, data.config.delivery.kuryrdobirka, data.config.delivery.kuryrzdarma),
             value: 'kuryr',
             disabled: false,
           }
        );
        if(selected=='') { selected='kuryr'; }
      }

    }
  }
});
</script>

{#await data}

{:then data}
 {#if data}
  <div>
    <List
      class="payment-select"
      singleSelection >
      {#each paymentOptions as item}
          <Item
            on:SMUI:action={() => (selected = item.value)}
            disabled={item.disabled}
            selected={selected === item.value}
          >
            <Text><span style="white-space: initial;">{@html item.title}</span></Text>
          </Item>
      {/each}
    </List>
  </div>
{/if}
{/await}

<link rel="stylesheet" href="bare.css" />

<style>

:root {
  --mdc-theme-primary: #0d6efd;
}

* :global(.payment-select) {
    max-width: 600px;
  }
</style>
